<template>
  <div class="wrapper">
    <div class="breadcrumb">{{$t("join.idea.title")}}</div>
    <div class="container idea">
      <!--<div class="text">{{$t("culture.idea.text")}}</div>-->
      <div class="box">
        <img src="~assets/culture/idea1.jpg"/>
      </div>
      <div class="text" v-html='$t("join.idea.text")'></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JoinIdea',
  data () {
    return {
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .wrapper
    width 78%
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
    .container
    .idea
      .text
        box-sizing border-box
        padding 0 23px
        margin-top 20px
        width 100%
</style>



// WEBPACK FOOTER //
// src/pages/join/components/Idea.vue